<h3>{{CustomerNameOrNew}}</h3>
<form #customerForm="ngForm"  name='ManageCustomer'>
<div id="main-customer-edit">
  <div id="work-area">
    <div id="row1">
      <div id="base-settings">
        <h5>Company Base Settings</h5>
        <div id="inlineDemandSupply" style=display:block>
          <label for="name">Name</label><input id="name" type="text" maxlength="50" [(ngModel)]="currentCustomer.Name" name="name" #name="ngModel" [attr.class]="testValidPullClass(name)"  required
            style="width:86%" />
          <div id="inputControls" *ngIf="!accountLinked">
            <div id="demandOrSupply" class="inputControlsRow dsButtons">
              <fieldset ngl-radio-group class="inputControlsRadioSpan">
                <label for="rdoDemand">Customer Type </label>
                <span id="radioButtons" style="position: relative;left: 15px;">
                  <ngl-radio-option label="Demand" style=display:inline [checked]="true">
                    <input id="rdoDemand" ngl type="radio" [checked]="true" (click)="onDemandClick()" />
                  </ngl-radio-option>
                  <ngl-radio-option label="Supply" style=display:inline>
                    <input id="rdoSupply" ngl type="radio" (click)="onSupplyClick()" />
                  </ngl-radio-option>
                </span>
              </fieldset>
              <br>
            </div>
          </div>
        </div>
        <div id="linkedAccount">
          <label>Linked Account </label>
          <kendo-dropdownlist id="ddlLinkedAccount" [data]="accountList" style="width:70%" *ngIf="!accountLinked"
            [(ngModel)]="currentCustomer.CustomerName" #CustomerName="ngModel"  name ="CustomerName" valueField="name" textField="name" [valuePrimitive]="true"
            (selectionChange)="linkedAccount_selectionChange($event)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>{{dataItem?.name}}</span>
            </ng-template>
          </kendo-dropdownlist>
          <kendo-dropdownlist id="ddlLinkedAccountDisabled" [data]="accountList" style="width:70%" *ngIf="accountLinked"
            [disabled]="accountLinked" [(ngModel)]="CustomerNameOrNew" [ngModelOptions]="{standalone: true}" >
          </kendo-dropdownlist>
        </div>
        <br>
        <div id="chainCodesInput"><label for="chainCodeList1"
            title="Enabled if Hotel Chain is checked. To restrict Chains that use Reverse Audit to their own hotels. ">Chain
            Codes</label>
          <input id="txtChainCodes" [disabled]="disableChainCodes" id="chainCodeList1" type="text"
            [(ngModel)]="chainCodeList" [ngModelOptions]="{standalone: true}" (blur)="updateChainCodeList()" /></div>
        <br>
        <ngl-checkbox label="Audits Require Approval Before Processing">
          <input id="chkApproval" ngl type="checkbox" [(ngModel)]="currentCustomer.RequiresAuditApproval" [ngModelOptions]="{standalone: true}" />
        </ngl-checkbox>
        <ngl-checkbox label="Audit Processing Will Include Rerun Logic">
          <input id="chkRerun" ngl type="checkbox"  [ngModelOptions]="{standalone: true}" [(ngModel)]="currentCustomer.RerunLogicActive" />
        </ngl-checkbox>
      </div>

      <div id="contract-settings">
        <h5>Contract Settings</h5>
        <div id="contract-desc">
          <p>Check or uncheck each option that the customer has purchased in their contract.</p>
          <p><strong>Note: </strong>Deactivating a feature for nonpayment or other reasons will not remove the
            associated jobs.
            Any jobs that have been processed will remain on file but will not be accessible.</p>
        </div>
        <div id="settings-for-contract">
          <ngl-checkbox label="Rate Audit"><input ngl type="checkbox"
              [(ngModel)]="contract.StandardRateAudit" [ngModelOptions]="{standalone: true}"/></ngl-checkbox>
          <ngl-checkbox class="indent" label="Length of Stay"><input ngl type="checkbox"
              [(ngModel)]="contract.AuditStd_LOSActive" [ngModelOptions]="{standalone: true}" /></ngl-checkbox>
          <ngl-checkbox class="indent" label="Quick Audit"><input id="chkQuickAudit" ngl type="checkbox"
              [(ngModel)]="currentCustomer.QuickAudit" [ngModelOptions]="{standalone: true}" [disabled]="!enableQuickAuditCheckBox" /></ngl-checkbox>
          <ngl-checkbox label="Rate Availability"><input id="chkRateAvailability" ngl type="checkbox"
              [(ngModel)]="contract.RateAvailability" [ngModelOptions]="{standalone: true}"  /></ngl-checkbox>
          <ngl-checkbox label="Reverse Audit"><input id="chkReverseAudit" ngl type="checkbox"
              [(ngModel)]="contract.ReverseAudit" [ngModelOptions]="{standalone: true}" /></ngl-checkbox>
          <br>
        </div>
      </div>
      <div id="gds-usage">
        <h5>GDS Usage Settings</h5>
        <div><label for="gus01">Amadeus: Threads to Utilize</label>
          <kendo-dropdownlist id="gus01" [data]="threadsOptions" [(ngModel)]="currentCustomer.AmadeusThreads"
            [valuePrimitive]="true" [allowCustom]="false" [ngModelOptions]="{standalone: true}" [popupSettings]="dropdownPopupSettings"></kendo-dropdownlist>
        </div>
        <div><label for="gus02">Apollo: Threads to Utilize</label>
          <kendo-dropdownlist id="gus02" [data]="threadsOptions" [(ngModel)]="currentCustomer.ApolloThreads"
            [valuePrimitive]="true" [allowCustom]="false" [ngModelOptions]="{standalone: true}" [popupSettings]="dropdownPopupSettings"></kendo-dropdownlist>
        </div>
        <div><label for="gus03">Galileo: Threads to Utilize</label>
          <kendo-dropdownlist id="gus03" [data]="threadsOptions" [(ngModel)]="currentCustomer.GalileoThreads"
            [valuePrimitive]="true" [allowCustom]="false" [ngModelOptions]="{standalone: true}" [popupSettings]="dropdownPopupSettings"></kendo-dropdownlist>
        </div>
        <div><label for="gus04">Sabre: Threads to Utilize</label>
          <kendo-dropdownlist id="gus04" [data]="threadsOptions" [ngModelOptions]="{standalone: true}" [(ngModel)]="currentCustomer.SabreThreads"
            [valuePrimitive]="true" [allowCustom]="false" [popupSettings]="dropdownPopupSettings"></kendo-dropdownlist>
        </div>
        <div><label for="gus05">Worldspan: Threads to Utilize</label>
          <kendo-dropdownlist id="gus05" [data]="threadsOptions" [ngModelOptions]="{standalone: true}" [(ngModel)]="currentCustomer.WorldspanThreads"
            [valuePrimitive]="true" [allowCustom]="false" [popupSettings]="dropdownPopupSettings"></kendo-dropdownlist>
        </div>
      </div>
    </div>
    <div id="row2">
      <div id="row2col1">
        <div id="amadeus">
          <div class="gds-set-head">
            <h6>Amadeus</h6><a (click)="onLoadDefaultCredentials(loadAmadeus)"><span
                class="cvt-icon-survey grid-cmd-icons"></span>Load Default Settings</a>
          </div>
          <div class="gds-box">
            <div>
              <div><label for="ginp01">Office ID</label><input id="ginp01" type="text" maxlength="10"
                  [(ngModel)]="gdsCredentials.AmadeusCredentials.OfficeID" [ngModelOptions]="{standalone: true}" /></div>
              <div><label for="ginp02">Duty Code</label><input id="ginp02" type="text" maxlength="2"
                  [(ngModel)]="gdsCredentials.AmadeusCredentials.DutyCode" [ngModelOptions]="{standalone: true}" /></div>
              <div><label for="ginp03">Organization</label><input id="ginp03" type="text" maxlength="16"
                  [(ngModel)]="gdsCredentials.AmadeusCredentials.Organization" [ngModelOptions]="{standalone: true}" /></div>
            </div>
            <div>
              <div><label for="ginp04">Login ID</label><input id="ginp04" type="text" maxlength="8"
                  [(ngModel)]="gdsCredentials.AmadeusCredentials.LoginID" [ngModelOptions]="{standalone: true}" /></div>
              <div class="double-up">
                <div><label for="ginp05">Data Type</label><input id="ginp05" type="text" maxlength="1"
                    [(ngModel)]="gdsCredentials.AmadeusCredentials.DataType" [ngModelOptions]="{standalone: true}" /></div>
                <div><label for="ginp06">Data Length</label><input id="ginp06" type="text" maxlength="2"
                    [(ngModel)]="gdsCredentials.AmadeusCredentials.DataLength" [ngModelOptions]="{standalone: true}" /></div>
              </div>
              <div><label for="ginp07">Password</label><input id="ginp07" type="password" maxlength="20"
                  [(ngModel)]="gdsCredentials.AmadeusCredentials.Password" [ngModelOptions]="{standalone: true}" /></div>
            </div>
          </div>
        </div>
        <div id="sabre">
          <div class="gds-set-head">
            <h6>Sabre</h6><a (click)="onLoadDefaultCredentials(loadSabre)"><span
                class="cvt-icon-survey grid-cmd-icons"></span>Load Default Settings</a>
          </div>
          <div class="gds-box">
            <div>
              <div><label for="ginp14">Login ID</label><input id="ginp14" type="text" maxlength="10"
                  [(ngModel)]="gdsCredentials.SabreCredentials.LoginId" [ngModelOptions]="{standalone: true}" /></div>
              <div><label for="ginp15">PCC</label><input id="ginp15" type="text" maxlength="8"
                  [(ngModel)]="gdsCredentials.SabreCredentials.PCC" [ngModelOptions]="{standalone: true}" /></div>
            </div>
            <div>
              <div><label for="ginp16">Password</label><input id="ginp16" type="password" maxlength="20"
                  [(ngModel)]="gdsCredentials.SabreCredentials.Password" [ngModelOptions]="{standalone: true}" /></div>
              <div style="display:inline">
                <div style="padding-top:5px;padding-left:10px;">
                  <ngl-checkbox id="chkSabreAAA" class="slds-checkbox" label="Use AAA"><input #chkEnable
                      ngl type="checkbox" [(ngModel)]="gdsCredentials.SabreCredentials.UseAAA" name ="chkSabreAAA" />
                  </ngl-checkbox>
                </div>
                <span id="sabrePCC" class="sabre" style="display:inline;padding-left:32px;">
                  <label>AAA Sabre PCC</label>
                  <input id="txtSabrePCC" type="text" [(ngModel)]="currentCustomer.SabreAAAPCC"  #SabreAAAPCC="ngModel" name="SabreAAAPCC"  
                    [disabled]="!chkEnable.checked" class="txtSabre" style="display:inline" maxlength="4" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="row2col2">
        <div id="apollo">
          <div class="gds-set-head">
            <h6>Apollo</h6><a (click)="onLoadDefaultCredentials(loadApollo)"><span
                class="cvt-icon-survey grid-cmd-icons"></span>Load Default Settings</a>
          </div>
          <div class="gds-box">
            <div><label for="ginp08">Profile</label><input id="ginp08" type="text" maxlength="25"
                [(ngModel)]="gdsCredentials.ApolloCredentials.Profile" [ngModelOptions]="{standalone: true}" /></div>
            <div><label for="ginp09">Login ID</label><input id="ginp09" type="text" maxlength="25"
                [(ngModel)]="gdsCredentials.ApolloCredentials.LoginId" [ngModelOptions]="{standalone: true}" /></div>
            <div><label for="ginp10">Password</label><input id="ginp10" type="password" maxlength="20"
                [(ngModel)]="gdsCredentials.ApolloCredentials.Password" [ngModelOptions]="{standalone: true}" /></div>
          </div>
        </div>
        <div id="worldspan">
          <div class="gds-set-head">
            <h6>Worldspan</h6><a (click)="onLoadDefaultCredentials(loadWorldspan)"><span
                class="cvt-icon-survey grid-cmd-icons"></span>Load Default Settings</a>
          </div>
          <div class="gds-box">
            <div><label for="ginp17">Profile</label><input id="ginp17" type="text" maxlength="25"
                [(ngModel)]="gdsCredentials.WorldspanCredentials.LoginId" [ngModelOptions]="{standalone: true}" /></div>
            <div><label for="ginp18">Password</label><input id="ginp18" type="password" maxlength="25"
                [(ngModel)]="gdsCredentials.WorldspanCredentials.Password" [ngModelOptions]="{standalone: true}" /></div>
            <div class="double-up">
              <div><label for="ginp19">PCC</label><input id="ginp19" type="text" maxlength="8"
                  [(ngModel)]="gdsCredentials.WorldspanCredentials.PCC" [ngModelOptions]="{standalone: true}" /></div>
              <div><label for="ginp20">Session</label><input id="ginp20" type="text" maxlength="10"
                  [(ngModel)]="gdsCredentials.WorldspanCredentials.Session" [ngModelOptions]="{standalone: true}" /></div>
            </div>
          </div>
        </div>
      </div>
      <div id="row2col3">
        <div id="galileo">
          <div class="gds-set-head">
            <h6>Galileo</h6><a (click)="onLoadDefaultCredentials(loadGalileo)"><span
                class="cvt-icon-survey grid-cmd-icons"></span>Load Default Settings</a>
          </div>
          <div class="gds-box">
            <div><label for="ginp11">Profile</label><input id="ginp11" type="text" maxlength="25"
                [(ngModel)]="gdsCredentials.GalileoCredentials.Profile" [ngModelOptions]="{standalone: true}" /></div>
            <div><label for="ginp12">Login ID</label><input id="ginp12" type="text" maxlength="25"
                [(ngModel)]="gdsCredentials.GalileoCredentials.LoginId" [ngModelOptions]="{standalone: true}" /></div>
            <div><label for="ginp13">Password</label><input id="ginp13" type="password" maxlength="20"
                [(ngModel)]="gdsCredentials.GalileoCredentials.Password" [ngModelOptions]="{standalone: true}" /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="buttons">
    <button class="k-button cvt-primary" (click)="onSaveCustomer()">Save Customer</button>
    <button class="k-button cvt-secondary" (click)="onCancel()">Cancel</button>
  </div>
</div>
</form> 
<app-modal (onOkToParent)='okCloseButtonClick(true)' (onCloseToParent)='okCloseButtonClick(false)' *ngIf='openModal'
  [dialogTitle]="dialogTitle" [dialogTextLine1]="dialogTextLine1" [dialogTextLine2]="dialogTextLine2"
  [primaryButtonText]="'OK'" [secondaryButtonText]="cancelButton"></app-modal>
<app-spinner [isBusy]="isBusy"></app-spinner>
